// Runtime config + shell selector. Precedence: query > localStorage > injected > default.
const injected = (typeof window !== "undefined" && window.__CONFIG) || {};

export function getConfig() { return injected; }

export function getShell() {
  const q = new URLSearchParams(location.search).get("shell");
  if (q === "v1" || q === "v2") return q;
  const ls = localStorage.getItem("cpq_shell");
  if (ls === "v1" || ls === "v2") return ls;
  return injected.shell === "v1" ? "v1" : "v2";  // v2 is the default shell
}

export function setShellOverride(v) {
  if (v === "v1" || v === "v2") localStorage.setItem("cpq_shell", v);
  else localStorage.removeItem("cpq_shell");
}
